import React, { useState } from "react";
import { Mail, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import useReveal from "../hooks/useReveal";
import { useToast } from "../hooks/use-toast";
import { useLang } from "../i18n/LanguageContext";

export default function Newsletter() {
  useReveal();
  const { toast } = useToast();
  const { t } = useLang();
  const [email, setEmail] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast({ title: t("news_ph") });
      return;
    }
    toast({ title: t("news_btn"), description: t("news_note") });
    setEmail("");
  };

  return (
    <section className="py-16 md:py-20 bg-slate-50">
      <div className="max-w-4xl mx-auto px-5 md:px-8 reveal">
        <div className="rounded-3xl bg-white border border-slate-100 shadow-sm p-8 md:p-12 text-center">
          <div className="w-12 h-12 rounded-xl bg-[#F5B400]/10 flex items-center justify-center mx-auto">
            <Mail className="w-6 h-6 text-[#F5B400]" />
          </div>
          <h2 className="mt-5 font-display text-2xl md:text-3xl font-bold text-black">{t("news_title")}</h2>
          <p className="mt-3 text-slate-500">{t("news_sub")}</p>
          <form onSubmit={submit} className="mt-6 flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("news_ph")} className="h-12 bg-slate-50 border-slate-200" data-testid="newsletter-input" />
            <Button type="submit" className="h-12 bg-[#F5B400] hover:bg-[#D99A00] text-neutral-900 rounded-lg px-6 font-semibold whitespace-nowrap" data-testid="newsletter-submit">
              {t("news_btn")} <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </form>
          <p className="mt-4 text-xs text-slate-400">{t("news_note")}</p>
        </div>
      </div>
    </section>
  );
}
